import { useRef } from 'react';
import type { FocusEventHandler, MouseEventHandler, PointerEventHandler } from 'react';

type UseStepInputFieldInteractionsParams = {
  isModalOpen: boolean | undefined;
  setIsModalOpen: (value: boolean) => void;
  setIsSuggestionsOpen: (value: boolean) => void;
};

type StepInputFieldInteractionHandlers = {
  onBlur: FocusEventHandler<HTMLDivElement>;
  onClick: MouseEventHandler<HTMLDivElement>;
  onFocus: FocusEventHandler<HTMLDivElement>;
  onMouseDown: MouseEventHandler<HTMLDivElement>;
  onPointerDown: PointerEventHandler<HTMLDivElement>;
};

const useStepInputFieldInteractions = ({
  isModalOpen,
  setIsModalOpen,
  setIsSuggestionsOpen,
}: UseStepInputFieldInteractionsParams): StepInputFieldInteractionHandlers => {
  const isPointerInteractionRef = useRef(false);

  const markPointerInteraction = () => {
    isPointerInteractionRef.current = true;
  };

  return {
    onBlur: () => {
      isPointerInteractionRef.current = false;
      setIsSuggestionsOpen(false);
    },
    onClick: () => {
      setIsModalOpen(!isModalOpen);
    },
    onFocus: (event) => {
      // React focus events bubble; ignore focus from inline inputs inside the field.
      if (event.target !== event.currentTarget) return;

      // Pointer focus fires before click, so click owns pointer activation while focus still opens the field for keyboard users.
      if (isPointerInteractionRef.current) return;

      setIsModalOpen(true);
    },
    onMouseDown: markPointerInteraction,
    onPointerDown: markPointerInteraction,
  };
};

export default useStepInputFieldInteractions;
